var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-title',{attrs:{"showAccountInfo":false}}),_c('login-form',{on:{"on-request-login":_vm.onRequestLogin,"on-reset-password":_vm.onResetPassword}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }